import { ref as dbRef, onValue } from 'firebase/database'
import { database } from './firebase'
import { evaluateUserSessionFromRTDB } from '@/utils/sessionGuard'

const USERS_BASE_PATH = 'projects/superkomprasBackoffice/users'

let unsubscribe = null

/**
 * Escucha cambios en el nodo del usuario autenticado (eliminación o cambio de status/rol).
 * @param {string} uid
 * @param {(result: { valid: boolean, reason?: string, error?: string }) => void} onInvalid
 */
export const startUserSessionWatch = (uid, onInvalid) => {
  stopUserSessionWatch()

  if (!uid || typeof onInvalid !== 'function') {
    return
  }

  const userRef = dbRef(database, `${USERS_BASE_PATH}/${uid}`)

  unsubscribe = onValue(userRef, snapshot => {
    if (!snapshot.exists()) {
      onInvalid({
        valid: false,
        reason: 'not_found',
        internalDetail: 'user node removed from RTDB',
      })
      return
    }

    const evaluation = evaluateUserSessionFromRTDB({
      uid,
      ...snapshot.val(),
    })

    if (!evaluation.valid) {
      onInvalid(evaluation)
    }
  })
}

export const stopUserSessionWatch = () => {
  if (typeof unsubscribe === 'function') {
    unsubscribe()
    unsubscribe = null
  }
}
